var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinical4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 107,
    viewBox: "0 0 117 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 107,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_7137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5602 31.3223H80.6617V79.6868C80.6617 82.3503 78.494 84.5232 75.8369 84.5232H40.315C37.6579 84.5232 35.4902 82.3503 35.4902 79.6868L35.5602 31.3223Z",
    fill: "white",
    stroke: "#05054B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6287 36.8599V28.0281C55.6986 26.7664 54.9993 25.0141 54.9993 23.8225C54.9993 22.6309 53.6008 22.701 53.6008 22.701H49.4753H48.846H44.7204C44.7204 22.701 43.3219 22.6309 43.3219 23.8225C43.3219 25.0141 42.6226 26.7664 42.6926 28.0281V36.8599C42.6926 36.8599 42.4828 38.6823 44.0911 38.6823H48.846C49.2655 38.6823 49.4753 38.6823 49.4753 38.6823H54.2302C55.8384 38.6823 55.6287 36.8599 55.6287 36.8599Z",
    fill: "#9E8959",
    stroke: "#9E8959",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1091 36.8599V28.0281C73.1791 26.7664 72.4798 25.0141 72.4798 23.8225C72.4798 22.6309 71.0813 22.701 71.0813 22.701H66.9557H66.3264H62.2009C62.2009 22.701 60.8024 22.6309 60.8024 23.8225C60.8024 25.0141 60.1031 26.7664 60.173 28.0281V36.8599C60.173 36.8599 59.9633 38.6823 61.5715 38.6823H66.3264C66.746 38.6823 66.9557 38.6823 66.9557 38.6823H71.7106C73.3189 38.6823 73.1091 36.8599 73.1091 36.8599Z",
    fill: "#995BA5",
    stroke: "#995BA5",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1953 25.1543V36.0889",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6758 25.1543V36.0889",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7676 26.4863V36.0891",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.248 26.4863V36.0891",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5527 26.4863V36.0891",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0332 26.4863V36.0891",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4395 39.1035V49.6175",
    stroke: "#05054B",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9219 39.1035V49.6175",
    stroke: "#05054B",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8086 39.1035V49.6175",
    stroke: "#05054B",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2891 39.1035V49.6175",
    stroke: "#05054B",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.377 49.6168V42.6074H53.1807",
    stroke: "#9E8959",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8574 49.6168V42.6074H70.6612",
    stroke: "#995BA5",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8092 45.4816V44.9209H49.6836V45.4816H53.8092Z",
    fill: "#33333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2916 45.4816V44.9209H67.166V45.4816H71.2916Z",
    fill: "#33333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8092 46.0421V45.7617H49.6836V46.0421H53.8092Z",
    fill: "#33333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2916 46.0421V45.7617H67.166V46.0421H71.2916Z",
    fill: "#33333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8092 46.8829V46.6025H49.6836V46.8829H53.8092Z",
    fill: "#33333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2916 46.8829V46.6025H67.166V46.8829H71.2916Z",
    fill: "#33333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8092 48.2152V48.0049H49.6836V48.2152H53.8092Z",
    fill: "#33333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2916 48.2152V48.0049H67.166V48.2152H71.2916Z",
    fill: "#33333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.901 49.336V49.0557H58.7754V49.336H62.901Z",
    fill: "#33333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9082 49.5469H80.2405",
    stroke: "#05054B",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_7137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.8496,
    height: 63.0841,
    fill: "white",
    transform: "translate(35 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinical4);
export default __webpack_public_path__ + "static/media/clinical_4.73c03df1eae6b381adea76ced95241a1.svg";
export { ForwardRef as ReactComponent };